import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppPaths, AppRouteNames } from '../app-paths.constants';
import { RedirectGuard } from '../shared/guards/redirect.guard';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { HomePageComponent } from './home-page/home-page.component';
import { HomeComponent } from './home.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: AppRouteNames.Home.Root,
        pathMatch: 'full',
        component: HomePageComponent,
        data: AppPaths.Home.Root.PageData
      },
      {
        path: AppRouteNames.Home.Contact,
        component: ContactPageComponent,
        data: AppPaths.Home.Contact.PageData
      },
      {
        path: AppRouteNames.Home.RulesWarsaw,
        canActivate: [RedirectGuard],
        data: { externalUrl: 'https://pja.edu.pl/dla-kandydata/#rekrutacja',
                externalEnUrl: 'https://pja.edu.pl/en/dla-kandydata/'}
      },
      {
        path: AppRouteNames.Home.RulesGdansk,
        canActivate: [RedirectGuard],
        data: { externalUrl: 'https://gdansk.pja.edu.pl/dla-kandydata' }
      },
      {
        path: AppRouteNames.Home.RulesBytom,
        canActivate: [RedirectGuard],
        data: { externalUrl: 'https://pja.edu.pl/informatyka-bytom/wymagania-dla-kandydatow/',
                externalEnUrl: 'https://pja.edu.pl/en/informatyka-bytom/wymagania-dla-kandydatow/'}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
